import React from 'react'
import { Link } from 'react-router-dom'

const OtherProjectsButton = () => {
  return (
    <Link to="/projects" id='backButton'>OTHER PROJECTS</Link>
  )
}

export default OtherProjectsButton